import { Box, IconButton } from "@mui/material";

import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from "@app/components";

const RowActions = ({ handleDelete, handleEdit }: any) => {
  const menuPopover = useMenuPopover();

  const actions = [
    { label: "Edit", callback: handleEdit },
    //  { label: "Delete", callback: handleDelete },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      <IconButton
        onClick={menuPopover.show}
        sx={{
          "&:hover": {
            backgroundColor: "transparent",
            opacity: 1,
          },
          padding: 0,
        }}
      >
        <Iconify
          icon="eva:more-vertical-fill"
          sx={{
            "&:hover": {
              transform: "none",
              opacity: 1,
            },
          }}
        />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
    </Box>
  );
};

export { RowActions };
